import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Field } from "formik";
import {
  createTopup,
  updateTopup,
} from "../../features/topupSlice";
import { successToastify } from "../../utils/toastify.util";
import FormBody, { InputError, LevelReq } from "../../components/form/FormBody";
import { addOnSchema } from "../../utils/validation.util";

const TopupModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const { fields, isBtnLoad, isRedirect } = useSelector((state) => state.topup);

  const handleSubmit = (values) => {
    const payload = {
      name: String(values.name || "").trim(),
      description: String(values.description || "").trim(),
      items: Number(values.items),
      teams: Number(values.teams),
      price: Number(values.price),
    };

    if (values.id) {
      dispatch(updateTopup({ ...payload, id: values.id }));
      return;
    }

    dispatch(createTopup(payload));
  };

  useEffect(() => {
    if (!isRedirect) return;

    if (fields.id) {
      successToastify(" Updated successfully.");
    } else {
      successToastify("Created successfully.");
    }
    closeModal();
  }, [closeModal, fields.id, isRedirect]);

  return (
    <FormBody
      initialValues={fields}
      enableReinitialize
      validationSchema={addOnSchema}
      onSubmit={handleSubmit}
    >
      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <LevelReq htmlFor="name" className="form-label">
              Name
            </LevelReq>
            <Field
              type="text"
              name="name"
              id="name"
              className="form-control"
            />
            <InputError name="name" />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <LevelReq htmlFor="price" className="form-label">
              Price
            </LevelReq>
            <Field
              type="number"
              step="0.01"
              min="0"
              name="price"
              id="price"
              className="form-control"
            />
            <InputError name="price" />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <LevelReq htmlFor="items" className="form-label">
              No of Challenges
            </LevelReq>
            <Field
              type="number"
              min="0"
              step="1"
              name="items"
              id="items"
              className="form-control"
            />
            <InputError name="items" />
          </div>
        </div>

        <div className="col-md-6">
          <div className="mb-3">
            <LevelReq htmlFor="teams" className="form-label">
              No of Teams
            </LevelReq>
            <Field
              type="number"
              min="0"
              step="1"
              name="teams"
              id="teams"
              className="form-control"
            />
            <InputError name="teams" />
          </div>
        </div>

        <div className="col-md-12">
          <div className="mb-3">
            <LevelReq htmlFor="description" className="form-label">
              Description
            </LevelReq>
            <Field
              as="textarea"
              name="description"
              id="description"
              className="form-control"
              style={{ resize: "none", height: "120px" }}
            />
            <InputError name="description" />
          </div>
        </div>
      </div>

      <Field type="hidden" name="id" />

      <div className="d-flex justify-content-end">
        <button
          type="submit"
          className="btn btn-outline-primary"
          disabled={isBtnLoad}
        >
          {isBtnLoad ? "Saving..." : "Save"}
        </button>
      </div>
    </FormBody>
  );
};

export default TopupModal;
